import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay/hooks'
import { FlexColumn, Text, Table as Tables, TablePagination } from 'elements'
import EmptyState from '../../common/EmptyState'
import TemplateRow from './TemplateRow'

const { Table, Body, Row, Cell } = Tables.Card

export default function TemplatesTable({ organization }) {
  const { data, ...paginationProps } = usePaginationFragment(
    graphql`
      fragment TemplatesTable_organization on Organization
        @argumentDefinitions(cursor: { type: "Cursor" }, count: { type: "Int", defaultValue: 10 })
        @refetchable(queryName: "TemplatesTablePaginationQuery") {
        reportTemplates(after: $cursor, first: $count, orderBy: CREATED_AT_DESC)
          @connection(key: "TemplatesTable_reportTemplates") {
          edges {
            node {
              id
              name
              deletedAt
              ...TemplateRow_reportTemplate
            }
          }
        }
      }
    `,
    organization,
  )

  if (!data) {
    return null
  }

  const templates = data.reportTemplates?.edges

  const hasTemplates = templates?.length

  return (
    <FlexColumn>
      <Text fontSize="xlarge" fontWeight="bold" mb="large">
        Report Templates
      </Text>
      <Table spacing="large">
        <Body>
          {hasTemplates ? (
            templates.map(({ node: template }) => (
              <TemplateRow template={template} key={template.id} />
            ))
          ) : (
            <Row>
              <Cell>
                <FlexColumn p="xxxlarge">
                  <EmptyState message="No report templates found." />
                </FlexColumn>
              </Cell>
            </Row>
          )}
        </Body>
        <TablePagination Table={Tables.Card} colSpan={2} {...paginationProps} />
      </Table>
    </FlexColumn>
  )
}
